import React from "react";
import { HEADLINE_PARTS } from "./heroContent";

const variantClass = {
  default: "text-white",
  soft: "text-white font-normal",
  accent: "bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-red-500",
};

const HeroHeadline = () => (
  <h1
    className="font-heading font-extrabold text-4xl md:text-5xl lg:text-6xl text-white leading-tight mt-4"
    data-testid="hero-headline"
  >
    {HEADLINE_PARTS.map((part, i) => (
      <span key={i} className={variantClass[part.variant]}>
        {part.text}
      </span>
    ))}
  </h1>
);

export default HeroHeadline;
